export const EmailFromTypes = {
    None: 0,
    Customer: 1,
    User: 2
};
